import React from "react";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
type AppProps = {
  data: any;
  tableHeader: string;
  tableHeaderData: TableHeadersType[];
};
const Gstr3BSixPointOneTableData = ({
  tableHeader,
  data,
  tableHeaderData,
}: AppProps) => {
  return (
    <>
      {data?.map((item: any) => {
        return (
          <tr key={item?.natureOfSupplies} style={{ whiteSpace: "nowrap" }}>
            {tableHeaderData?.map((header: any) => {
              if (header.value === "description") {
                return (
                  <td
                    style={{
                      fontWeight: item?.fullLength ? "500" : "",
                      borderRight: item?.fullLength ? "none" : "",
                    }}
                  >
                    <span>{item?.natureOfSupplies}</span>
                    {/* Future use */}
                    {/* {item?.isSource ? (
                      <span
                        style={{
                          color: "red",
                          marginLeft: "12px",
                          marginTop: "1px",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleGstrThreeBInvoiceListData("5_1")}
                      >
                        View Source
                      </span>
                    ) : null} */}
                  </td>
                );
              } else if (header.value === "total_count" && !item?.fullLength) {
                return (
                  <td>
                    {item?.tableRowData?.total_count
                      ? item?.tableRowData?.total_count
                      : 0}
                  </td>
                );
              } else if (
                header.value === "tax_paid_through_itc" &&
                !item?.fullLength
              ) {
                return (
                  <>
                    <td>
                      {typeof item?.tableRowData?.tax_paid_through_itc
                        ?.integrated_tax === "number" &&
                      item?.tableRowData?.tax_paid_through_itc?.integrated_tax
                        ? item?.tableRowData?.tax_paid_through_itc?.integrated_tax?.toFixed(
                            2
                          )
                        : "NA"}
                    </td>
                    <td>
                      {typeof item?.tableRowData?.tax_paid_through_itc
                        ?.central_tax === "number" &&
                      item?.tableRowData?.tax_paid_through_itc?.central_tax
                        ? item?.tableRowData?.tax_paid_through_itc?.central_tax?.toFixed(
                            2
                          )
                        : "NA"}
                    </td>
                    <td>
                      {typeof item?.tableRowData?.tax_paid_through_itc
                        ?.state_tax === "number" &&
                      item?.tableRowData?.tax_paid_through_itc?.state_tax
                        ? item?.tableRowData?.tax_paid_through_itc?.state_tax?.toFixed(
                            2
                          )
                        : "NA"}
                    </td>
                    <td>
                      {typeof item?.tableRowData?.tax_paid_through_itc?.cess ===
                        "number" &&
                      item?.tableRowData?.tax_paid_through_itc?.cess
                        ? item?.tableRowData?.tax_paid_through_itc?.cess?.toFixed(
                            2
                          )
                        : "NA"}
                    </td>
                  </>
                );
              } else if (
                header.value === "total_tax_payable" &&
                !item?.fullLength
              ) {
                return (
                  <td>
                    {typeof item?.tableRowData?.total_tax_payable ===
                      "number" && item?.tableRowData?.total_tax_payable
                      ? item?.tableRowData?.total_tax_payable?.toFixed(2)
                      : "NA"}
                  </td>
                );
              } else if (
                header.value === "tax_paid_in_cash" &&
                !item?.fullLength
              ) {
                return (
                  <td>
                    {typeof item?.tableRowData?.tax_paid_in_cash === "number" &&
                    item?.tableRowData?.tax_paid_in_cash
                      ? item?.tableRowData?.tax_paid_in_cash?.toFixed(2)
                      : "NA"}
                  </td>
                );
              } else if (
                header.value === "interest_paid_in_cash" &&
                !item?.fullLength
              ) {
                return (
                  <td>
                    {typeof item?.tableRowData?.interest_paid_in_cash ===
                      "number" && item?.tableRowData?.interest_paid_in_cash
                      ? item?.tableRowData?.interest_paid_in_cash?.toFixed(2)
                      : "NA"}
                  </td>
                );
              } else if (
                header.value === "late_fee_paid_in_cash" &&
                !item?.fullLength
              ) {
                return (
                  <>
                    <td>
                      {typeof item?.tableRowData?.late_fee_paid_in_cash ===
                        "number" && item?.tableRowData?.late_fee_paid_in_cash
                        ? item?.tableRowData?.late_fee_paid_in_cash?.toFixed(2)
                        : "NA"}
                    </td>
                  </>
                );
              } else {
                return !item?.fullLength && <td>NA</td>;
              }
            })}
          </tr>
        );
      })}
    </>
  );
};

export default Gstr3BSixPointOneTableData;
